module.exports = __webpack_public_path__ + "static/media/SarahSwitek_14_ActivitiesConclusion_3.5c0fd1ab.mp3";